import React from "react";

const About = () => {
  return (
    <div className="flex flex-1 gap-7 flex-col  md:flex-row">
      <span className="font-montserrat text-primary font-normal text-xl flex md:w-3/12">
        Providing high-caliber recruitment services Since 1989
      </span>
      <span className="font-montserrat text-primary font-medium text-xs flex md:w-7/12 text-justify leading-6 whitespace-pre-line">
        Providing high-caliber recruitment services Since 1989 Lorem ipsum dolor
        sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
        ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
        exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
        dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
        proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        {"\n\n"}
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
        veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
        commodo consequat.
      </span>
    </div>
  );
};

export default About;
